import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { BiX } from "react-icons/bi";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { getAllStates } from "../../redux/thunk";
import { State } from "../../types/types";

export default function WareHouse() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const {
    allStates: states,
    allStatesStatus: status,
    allStatesError: error,
  } = useAppSelector((store) => store.warehouse);

  useEffect(() => {
    if (status === "idle" || status === "failed") {
      dispatch(getAllStates());
    }
  }, [status, dispatch]);

  const handleStateSelect = (stateId: string, stateName: string) => {
    navigate(`/dashboard/warehouse-management/${stateId}`);
  };

  const handleSeeMore = () => {
    console.log("See More clicked - implement pagination or full list logic");
  };

  const handleAddStore = () => {
    navigate("/dashboard/warehouse-management/add-store");
  };

  let content;

  if (status === "loading") {
    content = (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#008B50]"></div>
      </div>
    );
  } else if (status === "succeeded") {
    content = (
      <div className="bg-white rounded-lg shadow-md p-0 relative max-w-xs mx-auto md:mx-0">
        <button
          className="absolute right-3 top-3 p-1 text-gray-500 hover:text-gray-800 hover:bg-gray-100 rounded-full z-10 transition duration-150 ease-in-out"
          onClick={() => navigate("/dashboard")}
          aria-label="Close"
        >
          <BiX size={24} />
        </button>
        <div className="flex flex-col divide-y divide-gray-100 pt-10 pb-4 max-h-[60vh] overflow-y-auto">
          {states.length > 0 ? (
            states.map((stateItem: State) => (
              <button
                key={stateItem._id}
                className="flex items-center w-full text-left py-3 px-4 hover:bg-gray-50 transition duration-150 ease-in-out"
                onClick={() =>
                  handleStateSelect(stateItem._id, stateItem.state)
                }
              >
                <img
                  src={stateItem.stateIcon || "/placeholder.svg"}
                  alt={stateItem.state}
                  className="w-8 h-8 mr-3 object-contain flex-shrink-0"
                />

                <span className="text-base font-medium text-gray-800">
                  {stateItem.state}
                </span>
              </button>
            ))
          ) : (
            <p className="text-center text-gray-500 p-4">
              No states available.
            </p>
          )}
        </div>

        {states.length > 9 && (
          <div className="pb-6 pt-2 flex justify-center border-t border-gray-100">
            <button
              onClick={handleSeeMore}
              className="bg-[#F0FDF4] text-[#008B50] px-6 py-1.5 rounded-full text-sm font-medium hover:bg-[#E0FCEC] transition duration-150 ease-in-out"
            >
              See More
            </button>
          </div>
        )}
      </div>
    );
  } else if (status === "failed") {
    content = (
      <div className="text-center text-red-600 bg-red-50 p-4 rounded-md max-w-xs mx-auto md:mx-0">
        Error: {error || "Could not fetch states."}
        <button
          onClick={() => dispatch(getAllStates())}
          className="ml-2 text-sm font-medium text-blue-600 hover:underline"
        >
          Retry
        </button>
      </div>
    );
  } else {
    content = (
      <div className="text-center text-gray-500 p-4">Loading states...</div>
    );
  }

  return (
    <div className="px-4 md:px-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-xl font-semibold text-gray-800">
          Manage Store - Select State
        </h1>
        <button
          className="bg-[#008B50] text-white px-5 py-1.5 rounded text-sm font-medium hover:bg-[#007A48] transition duration-150 ease-in-out"
          onClick={handleAddStore}
        >
          Add New Store
        </button>
      </div>

      {content}
    </div>
  );
}
